export const SWIPER_OPTIONS = {
  slidesPerView: 1.15,
  spaceBetween: 16,
  breakpoints: {
    768: {
      slidesPerView: 2.2,
    },
    1024: {
      spaceBetween: 24,
      slidesPerView: 3.2,
    },
    1200: {
      slidesPerView: 4,
      allowTouchMove: false,
    },
  },
};

export const LAMAPOLL_URL = 'https://survey.lamapoll.de/Feedback-DPA/';

export const CONTACT_EMAIL = 'meine.pflege@pflege.de';
export const OBJECTION_EMAIL = 'betroffenenrechte@pflege.de';

export const PRESS_URL = 'https://www.pflege.de/presse';

export const EDITHCARE_APPLICATION_LINK = `${window?.config?.EDITHCARE_APPLICATION_LINK}`;
